import { createReferenceListModule } from "./create-reference-list-module.js";
import { mergeReferenceListEntries } from "./reference-list-entries.js";

export const SESSION_TARGET_GROUP_IDS = Object.freeze([
  "children",
  "youth",
  "women",
  "men",
  "childrenYouth",
  "adults",
]);

/** Nur diese Zielgruppen sind für neue Mandanten standardmäßig aktiv. */
export const SESSION_TARGET_GROUP_DEFAULT_ENABLED_IDS = Object.freeze([
  "children",
  "adults",
]);

function defaultSessionTargetGroupEntriesInternal() {
  const enabled = new Set(SESSION_TARGET_GROUP_DEFAULT_ENABLED_IDS);
  return SESSION_TARGET_GROUP_IDS.map((id, index) => ({
    id,
    builtin: true,
    enabled: enabled.has(id),
    sort: (index + 1) * 10,
    isDefault: id === "children",
  }));
}

export const SESSION_COURT_FORMAT_IDS = Object.freeze([
  "kleinfeld",
  "midcourt",
  "grossfeld",
]);

export const sessionTargetGroupsModule = createReferenceListModule({
  listKey: "sessionTargetGroups",
  builtinIds: SESSION_TARGET_GROUP_IDS,
  labelKeyForId: (id) => `trainerstunden.group.${id}`,
  customIdPrefix: "target_group_custom_",
  customDbStoresId: true,
});

export const sessionCourtFormatsModule = createReferenceListModule({
  listKey: "sessionCourtFormats",
  builtinIds: SESSION_COURT_FORMAT_IDS,
  labelKeyForId: (id) => `trainerstunden.courtFormat.${id}`,
  customIdPrefix: "court_format_custom_",
  customDbStoresId: true,
});

export const defaultSessionTargetGroupEntries =
  defaultSessionTargetGroupEntriesInternal();

export function resolveSessionTargetGroupEntries(lists) {
  const configured =
    lists && typeof lists === "object" ? lists.sessionTargetGroups : null;
  return mergeReferenceListEntries(
    configured,
    defaultSessionTargetGroupEntriesInternal(),
  ).filter((row) => row.enabled !== false);
}

export const resolveSessionTargetGroupEntriesForAdmin =
  sessionTargetGroupsModule.resolveEntriesForAdmin;
export const resolveSessionTargetGroupLabel =
  sessionTargetGroupsModule.resolveLabel;
export const resolveSessionTargetGroupLabelById =
  sessionTargetGroupsModule.resolveLabelById;
export const isAllowedSessionTargetGroupId =
  sessionTargetGroupsModule.isAllowedId;

export const defaultSessionCourtFormatEntries =
  sessionCourtFormatsModule.defaults;
export const resolveSessionCourtFormatEntries =
  sessionCourtFormatsModule.resolveEntries;
export const resolveSessionCourtFormatEntriesForAdmin =
  sessionCourtFormatsModule.resolveEntriesForAdmin;
export const resolveSessionCourtFormatLabel =
  sessionCourtFormatsModule.resolveLabel;
export const resolveSessionCourtFormatLabelById =
  sessionCourtFormatsModule.resolveLabelById;
export const isAllowedSessionCourtFormatId =
  sessionCourtFormatsModule.isAllowedId;

/**
 * @param {unknown} lists
 * @param {(key: string) => string} t
 * @param {{ includeUnset?: boolean, unsetLabelKey?: string }} [options]
 */
export function buildSessionTargetGroupPickerItems(lists, t, options = {}) {
  const rows = resolveSessionTargetGroupEntries(lists).map((entry) => ({
    value: entry.id,
    label: resolveSessionTargetGroupLabel(entry, t),
  }));
  if (options.includeUnset) {
    return [
      {
        value: "",
        label: t(options.unsetLabelKey || "trainerstunden.planning.fieldDash"),
      },
      ...rows,
    ];
  }
  return rows;
}

/**
 * @param {unknown} lists
 * @param {(key: string) => string} t
 */
export function buildSessionCourtFormatPickerItems(lists, t) {
  return [
    { value: "", label: t("trainerstunden.session.courtFormat.unset") },
    ...resolveSessionCourtFormatEntries(lists).map((entry) => ({
      value: entry.id,
      label: resolveSessionCourtFormatLabel(entry, t),
    })),
  ];
}
